module.exports = $rdf;